import { SVGProps } from 'react';

export const DoubleArrowDown = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            d="M5.64678 6.35315L11.6468 12.3531C11.8405 12.5469 12.1593 12.5469 12.353 12.3531L18.353 6.35315C18.5468 6.1594 18.5468 5.84065 18.353 5.6469C18.1593 5.45315 17.8405 5.45315 17.6468 5.6469L11.9999 11.2938L6.35303 5.6469C6.15928 5.45315 5.84053 5.45315 5.64678 5.6469C5.45303 5.84065 5.45303 6.1594 5.64678 6.35315ZM5.64678 12.3531L11.6468 18.3531C11.8405 18.5469 12.1593 18.5469 12.353 18.3531L18.353 12.3531C18.5468 12.1594 18.5468 11.8406 18.353 11.6469C18.1593 11.4531 17.8405 11.4531 17.6468 11.6469L11.9999 17.2938L6.35303 11.6469C6.15928 11.4531 5.84053 11.4531 5.64678 11.6469C5.45303 11.8406 5.45303 12.1594 5.64678 12.3531Z"
            fill="currentColor"
        />
    </svg>
);
